import Api from 'services/Api';
class Uploader {
	upload(file, end, onUploadProgress) {
		let formData = new FormData();
		formData.append("file", file);

		return Api.upload(formData, '/media_objects', end, onUploadProgress);
	}
}

export default new Uploader();
